import SportLoader from "../sport/sport-loader";
import NavControl from "../sport/nav-control";
import DBHandler from "../index-db/db-handler";
import WebSpeech from "../webSpeechAPI/webSpeech";
import { Timestamp, Loop_Timer } from "../utils/utils";
import Auth from "./auth";
// Cache config is now handled by Vite PWA plugin
const CACHE_CONFIG = {
  prefix: 'sme-scoring',
  suffix: 'v1.7.015', // Incremented for Vite migration
  precache: 'precache',
  runtime: 'runtime',
  googleAnalytics: 'ga'
};
import { SessionStorage } from "../utils/game-utils";

const getCacheName = (name) => { return `${CACHE_CONFIG.prefix}-${name}-${CACHE_CONFIG.suffix}`; };
const getCacheVersion = () => { return CACHE_CONFIG.suffix; }; 

const STATIC_LOOP_TIMERS = {
  push_match_loader_timer: new Loop_Timer('push-match_loader-refresh', 10),
  push_match_timer: new Loop_Timer('push-match-refresh', 5),
  watch_timer: new Loop_Timer('connection-indicator-refresh', 5),
  background_sound_timer: new Loop_Timer('background-sound-indicator-refresh', 5),
}

const STATIC_BACKGROUNDs = {
  Default: { value: 'var(--background-blue)' },
  Light: { value: 'var(--background-light)' },
  Dark: { value: 'var(--background-dark)' },
  Blue: { value: 'var(--background-blue)' },
  Green: { value: 'var(--background-green)' },
  Pink: { value: 'var(--background-pink)' },
  Purple: { value: 'var(--background-purple)' },
  Linear: { value: 'var(--background-linear)' },
}

const STATIC_IMAGES = {
  SMEGold: '/images/defaultSponsors/SMEGold.png',
}

var LOCKS = {
  lock: new WeakMap(),
  update_match_lock: {},
  get_token_lock: {},
}

var GLOBAL_VARS = {
  cast_running: false,
  keep_alive_seconds: 0,
  app_initiated: false,
  server_connection: true,
  background_sound_playing: false,
  // free_app: true,
  free_app: false,
  matched_changed: performance.now(), // Deprecated - use syncTrigger.trigger() instead
  last_sync_time: performance.now(), // Deprecated - replaced by SyncTrigger
  syncTrigger: null, // SyncTrigger instance - set by ServiceLauncher
  cache_version: getCacheVersion(), // Current cache version from service worker
  session_storage: new SessionStorage(),
}

var GLOBAL_CSS = {
  background: { "--background": 'var(--background-blue)' },
}

var OVERLAY = {
  hide: null,
  show: null,
  element: null,
  sts: null
};

var SETTINGS = {
  background: 'Default',
  voice: 'unset',
  speech_rate: 1.4,
  mute: false,
  last_message: '',
  cast_voice: '',
  cast_speech_rate: 1.4,
  cast_border_size: 1,
}

var SPORT_LIST = [
  {
    id: 'Squash',
    name: 'Squash',
    image: 'images/sportIcons/Squash.png',
  },
  {
    id: 'Pickleball',
    name: 'Pickleball',
    image: 'images/sportIcons/Pickleball.png',
  },
  {
    id: 'Padel',
    name: 'Padel',
    image: 'images/sportIcons/Padel.png',
  },
  {
    id: 'Tennis',
    name: 'Tennis',
    image: 'images/sportIcons/Tennis.png',
  },
  // {
  //   id: 'TableTennis',
  //   name: 'Table Tennis',
  //   image: 'images/sportIcons/TableTennis.png',
  // },
  // {
  //   id: 'Badminton',
  //   name: 'Badminton',
  //   image: 'images/sportIcons/Badminton.png',
  // },
  {
    id: 'Scoring21',
    name: 'Scoring21',
    image: 'images/sportIcons/Scoring21.png',
  },
  {
    id: 'Racketlon',
    name: 'Racketlon',
    image: 'images/sportIcons/Racketlon.png',
  },
]


const load_SportLoader_from_db = (init = true) => {
  return new Promise(async (resolve) => {
    const dbHandler = DBHandler();
    const settings = await dbHandler.load_settings();

    // console.log('load_SportLoader_from_db - settings: ', settings);
    // console.log('load_SportLoader_from_db - settings.free_app: ', settings.free_app);
    // console.log('load_SportLoader_from_db - settings.free_app typeof : ', typeof settings?.free_app);

    if (typeof settings?.free_app === 'boolean') {
      GLOBAL_VARS.free_app = settings.free_app;
    }

    const sport = typeof settings === 'undefined' ? 'Squash' : settings.sport;
    resolve(new SportLoader(true, sport));
  });
}

var SPORT_BASE = await load_SportLoader_from_db(true);
var NAV_CONTROL = new NavControl();
var SME_AUTH = Auth();











const Update_GLOBAL_CSS = (option, value) => {
  let didUpdate = false;
  switch (option) {
    case 'background':
      const cssValue = STATIC_BACKGROUNDs[value];
      if (typeof cssValue !== 'undefined' && cssValue.value !== '') {
        const newValue = { "--background": cssValue.value };
        if (JSON.stringify(newValue) !== JSON.stringify(GLOBAL_CSS.background)) {
          GLOBAL_CSS.background = newValue;
          didUpdate = true;
        }
      }
      break;
    default:
      console.error('ERROR - Update_GLOBAL_CSS: Option not set: ', option);
      break;
  }
  return didUpdate;
}

const load_DB_vars = () => {
  return new Promise(async (resolve) => {
    // console.log('>>> load_DB_vars <<<');
    const dbHandler = DBHandler();
    const settings = await dbHandler.loadSettings();
    SETTINGS = settings;
    Update_GLOBAL_CSS('background', SETTINGS.background);
    const speechObj = WebSpeech();
    await speechObj.populateVoiceList_promise();
    GLOBAL_VARS.app_initiated = true;
    resolve(true);
  });
}


const refresh_sport_base = () => {
  return new Promise(async (resolve) => {
    const dbHandler = DBHandler();
    SPORT_BASE = await load_SportLoader_from_db(true); 
    await dbHandler.update_app_state({ update: Timestamp() });

    resolve(true);
  });
}


export {
  OVERLAY,
  SETTINGS,
  SPORT_BASE,
  NAV_CONTROL,
  GLOBAL_VARS,
  GLOBAL_CSS,
  STATIC_IMAGES,
  SPORT_LIST,
  LOCKS,
  SME_AUTH,
  Update_GLOBAL_CSS,
  load_DB_vars,
  load_SportLoader_from_db,
  refresh_sport_base,
  getCacheName,
  getCacheVersion,
  CACHE_CONFIG,
  STATIC_LOOP_TIMERS
}